<a pButton
   [routerLink]="route()"
   [severity]="severity()"
   [class.w-full]="wide()"
   [class.max-w-60]="wide()"
   [queryParams]="routeQueryParams()"
   [size]="size()"
   [class.font-semibold]="bolder()"
>{{ buttonLabel() }}</a>
